import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Button,
  Flex,
  Image,
  HStack,
} from '@chakra-ui/react';
import { FiLogOut } from 'react-icons/fi';

function Header({ onLogout }) {
  return (
    <Box bg="white" borderBottom="1px" borderColor="gray.200">
      <Container maxW="full" px={6} py={4}>
        <Flex justify="space-between" align="center">
          <HStack spacing={4} align="center">
            <Image
              src="/forceniques.png"
              alt="Forceniques Logo"
              boxSize="80px"
              objectFit="contain"
            />
            <VStack align="start" spacing={1}>
              <Heading size="lg" color="gray.900" fontWeight="bold">
                Forceniques
              </Heading>
              <Text color="gray.600" fontSize="sm">
                Forensics Power Rangers / Opération Toblerone
              </Text>
            </VStack>
          </HStack>
          
          <Button
            size="sm"
            variant="outline"
            colorScheme="red"
            onClick={onLogout}
            leftIcon={<FiLogOut />}
          >
            Logout
          </Button>
        </Flex>
      </Container>
    </Box>
  );
}

export default Header;
